import React from "react";
import styles from "./payment-method-transaction-filter.module.scss";
import { Field } from "components/commons";
import { locale } from "localization/en";
import SearchTypeField from "components/commons/search-field/search-type";

const PaymentMethodTransactionFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const searchType = [
    { label: locale.referenceNo, value: "refNumber" },
    { label: locale.transactionNo, value: "transactionNo" },
  ];

  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Field className={styles.search}>
          <SearchTypeField
            placeholder={locale.keyword}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={searchType}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
      </div>
    </div>
  );
};

export default PaymentMethodTransactionFilter;
